import React from 'react';
import PropTypes from 'prop-types';
import { Error, CheckCircle, Warning, ErrorOutline, CheckCircleOutline } from '@material-ui/icons';
import { Typography, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { colors } from '../common';

const inlineStyles = {
	errorIconStyle: {
		color: colors.contrastColor,
		fontSize: 15,
		marginRight: 5
	},
	warningIconStyle: {
		color: colors.warningColor,
		fontSize: 15,
		marginRight: 5
	},
	successIconStyle: {
		color: colors.secondaryColor,
		fontSize: 15,
		marginRight: 5
	},
	iconStyle: {
		marginRight: 5,
		fontSize: 15,
		verticalAlign: 'middle'
	}
};
class FormStatusComponent extends React.Component {
	renderDefaultError = () => {
		const { error, success, warning, classes } = this.props;
		if (error) {
			return (
				<Typography
					variant="caption"
					className={`${classes.container} flex-container horizontal start-start`}
				>
					<Error style={inlineStyles.errorIconStyle} />
					{error}
				</Typography>
			);
		}
		if (success) {
			return (
				<Typography variant="caption" className="success-container horizontal">
					<CheckCircle style={inlineStyles.successIconStyle} />
					<span className="success-text">{success}</span>
				</Typography>
			);
		}
		return (
			<Typography variant="caption" className="warning-container horizontal">
				<Warning style={inlineStyles.warningIconStyle} />
				<span className="warning-text">{warning}</span>
			</Typography>
		);
	};

	close = () => {};

	renderPopoverError = () => {
		const { error, success, warning, classes, popupPlacement } = this.props;
		if (error) {
			return (
				<Tooltip
					open
					title={error}
					placement={popupPlacement}
					classes={{
						tooltip: classes.errorTooltip,
						tooltipPlacementRight: classes.tooltipPlacementRightStyle
					}}
				>
					<ErrorOutline style={inlineStyles.errorIconStyle} />
				</Tooltip>
			);
		}
		if (success) {
			return (
				<Tooltip title={success}>
					<CheckCircleOutline />
				</Tooltip>
			);
		}
		return (
			<Tooltip title={warning}>
				<Warning />
			</Tooltip>
		);
	};

	render() {
		const { popover } = this.props;
		if (!popover) {
			return this.renderDefaultError();
		}
		return this.renderPopoverError();
	}
}

const styles = () => ({
	tooltipPlacementRightStyle: {
		margin: '0 5px'
	},
	errorTooltip: {
		backgroundColor: colors.contrastColor,
		color: colors.secondaryTextColor
	},
	container: {
		display: 'flex',
		width: 'auto',
		margin: 0,
		paddingTop: 3,
		color: colors.errorColor
	}
});
FormStatusComponent.propTypes = {
	popover: PropTypes.bool,
	error: PropTypes.string,
	success: PropTypes.string,
	warning: PropTypes.string,
	popupPlacement: PropTypes.string,
	classes: PropTypes.object
};
FormStatusComponent.defaultProps = {
	popover: false,
	popupPlacement: 'bottom-end'
};
export default withStyles(styles)(FormStatusComponent);
